import axios from "@/axios";

const getTenantTemplates = async() => {
    const url = `/report-builder/templates`;
    try {
        const { data } = await axios.get(url);
        return data;
    } catch (error) {
        console.warn(error.response.data.detail || "Failed to fetch templates");
    }
}

const getTemplatePermissions = async({ templateId, packageId }) => {
    const url = `/report-builder/package/${packageId}/template/${templateId}/permissions`;
    try {
        const { data } = await axios.get(url);
        return data;
    } catch (error) {
        console.warn(error.response.data.detail || "Failed to fetch template permissions");
    }
}

const updateTemplatePermissions = async({ templateId, packageId, data: payload }) => {
    const url = `/report-builder/package/${packageId}/template/${templateId}/permissions`;
    try {
        const { data } = await axios.put(url, payload);
        return data;
    } catch (error) {
        console.warn(error.response.data.detail || "Failed to update template permissions");
    }
}

const getFileUrl = async(templateId) => {
    const url = `/report-builder/template/${templateId}/file-url`;
    try {
        const { data } = await axios.get(url);
        return data.url || "";
    } catch (error) {
        console.warn(error.response.data.detail || "Failed to fetch templates");
    }
}

export {
    getTenantTemplates,
    getTemplatePermissions,
    updateTemplatePermissions,
    getFileUrl
}



